/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prefix: NonNullable<unknown>, lastIndex: NonNullable<unknown> }} Image_Export_Summary_PrefixInputs */



/**
* | output |
* | --- |
* | "Prefix: {prefix}0001.png → {prefix}{lastIndex}.png" |
*
* @param {Image_Export_Summary_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_summary_prefix = /** @type {((inputs: Image_Export_Summary_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Summary_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Prefixe : ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Präfix: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Prefisso: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Префикс: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Prefijo: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`前缀：${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プレフィックス: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपसर्ग: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Prefixo: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
	return /** @type {LocalizedString} */ (`Prefix: ${i?.prefix}0001.png → ${i?.prefix}${i?.lastIndex}.png`)
});